<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="60%" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        " :bodyStyle="{ maxHeight: '75vh', overflow: 'auto' }">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="是否启用">
                    <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.status"></a-switch>
                </a-form-item>
                <a-form-item label="活动名称" name="name" required>
                    <a-input placeholder="请输入" v-model:value="formState.name"></a-input>
                </a-form-item>
                <a-form-item label="平台名称" name="platform_id" required>
                    <a-select allow-clear v-model:value="formState.platform_id" placeholder="请选择平台"
                        :disabled="state.isEdit">
                        <a-select-option v-for="(item, index) in state.platformList" :key="index" :value="item.id">{{
                            item.platform_abbreviation }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="业务类型" name="business_types" required>
                    <a-checkbox-group v-model:value="formState.business_types">
                        <a-checkbox :value="1">设立</a-checkbox>
                        <a-checkbox :value="2">同区迁入</a-checkbox>
                        <a-checkbox :value="3">跨区迁入</a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item label="主体类型" name="main_types" required>
                    <a-checkbox-group v-model:value="formState.main_types">
                        <a-checkbox :value="1">公司</a-checkbox>
                        <a-checkbox :value="2">个体户</a-checkbox>
                        <a-checkbox :value="3">个人独资企业</a-checkbox>
                        <a-checkbox :value="4">合伙企业</a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item label="注册类型" name="registration_types" required>
                    <a-checkbox-group v-model:value="formState.registration_types">
                        <a-checkbox :value="1">包注册</a-checkbox>
                        <a-checkbox :value="2">出裸地址</a-checkbox>
                    </a-checkbox-group>
                    <a>一次性收费和续费都不参与活动</a>
                </a-form-item>
                <a-form-item label="参与订单的录单时间区间" name="start_time" required>
                    <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                        @change="rangTimeChange" :format="format"></a-range-picker>
                </a-form-item>
                <a-form-item label="实付金额" name="queue_price" required>
                    <a-input placeholder="参加活动实付金额，代理商拿货价必须等于此值" v-model:value="formState.queue_price"
                        addonAfter="元"></a-input>
                </a-form-item>
                <a-form-item name="out_type" label="活动结束方式" required>
                    <a-radio-group v-model:value="formState.out_type" button-style="solid">
                        <a-radio-button :value="1">按参与订单数</a-radio-button>
                        <a-radio-button :value="2">按出局总人数</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="参与订单数等于" name="max_out_num" required v-if="formState.out_type == 1">
                    <a-input placeholder="等于此人数则活动立即停止" v-model:value="formState.max_out_num"
                        addonAfter="人，立即停止活动"></a-input>
                </a-form-item>
                <a-form-item label="出局总人数等于" name="max_out_num" required v-if="formState.out_type == 2">
                    <a-input placeholder="等于此人数则活动立即停止" v-model:value="formState.max_out_num"
                        addonAfter="人，立即停止活动"></a-input>
                </a-form-item>
                <a-form-item name="end_after_action" label="活动结束后为所有未出局订单" required>
                    <a-radio-group v-model:value="formState.end_after_action" button-style="solid">
                        <a-radio-button :value="1">结算优惠券</a-radio-button>
                        <a-radio-button :value="2">继续返利直到出局</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="活动结束结算优惠券单张金额" name="end_after_base_coupon" required
                    v-if="formState.end_after_action == 1">
                    <a-input placeholder="单张优惠券金额" v-model:value="formState.end_after_base_coupon"
                        addonAfter="元"></a-input>
                </a-form-item>
                <a-form-item label="出局金额" name="out_money" required>
                    <a-input placeholder="超过此金额就拿优惠券出局" v-model:value="formState.out_money" addonAfter="元则出局"
                        addonBefore="满"></a-input>
                </a-form-item>
                <a-form-item label="每单拿出返现金额" name="take_money" required>
                    <a-input placeholder="每单拿出返现金额" v-model:value="formState.take_money" addonAfter="元"></a-input>
                </a-form-item>
                <a-form-item label="同时返现人数" name="free_user_num" required>
                    <a-input placeholder="同时返现人数" v-model:value="formState.free_user_num" addonAfter="人"></a-input>
                </a-form-item>
                <a-form-item label="每单返现比例" name="free_rate" required>
                    <template v-for="(item, index) in Number(formState.free_user_num)" :key="index">
                        <a-form-item-rest>
                            <a-input placeholder="金额递减" v-model:value="formState.free_rate[index]" addonAfter="元"
                                :addonBefore="'第' + item + '人：'"></a-input>
                        </a-form-item-rest>
                    </template>
                    <p>
                        <span>累计金额：<span style="color: red">{{ free_rateTotal }}</span>元；</span>
                        <span v-if="free_rateTotal > formState.take_money" style="color: red">累计金额不能大于【每单拿出返现金额】</span>
                        <span v-else>剩余金额：<span style="color: red">{{ formState.take_money - free_rateTotal
                                }}</span>元</span>
                    </p>
                </a-form-item>
                <a-form-item label="用户最大参与次数">
                    <a-input placeholder="0为不限制" v-model:value="formState.per_user_jointimes" addonAfter="次"></a-input>
                </a-form-item>
                <a-form-item label="限定参与用户组" name="restricted_roles">
                    <a-select allow-clear placeholder="请选择角色" v-model:value="formState.restricted_roles"
                        mode="multiple">
                        <a-select-option v-for="(item, index) in state.roleOptions" :key="index" :value="item.name">{{
                            item.display_name
                            }}</a-select-option>
                    </a-select>
                    不选则为不限制
                </a-form-item>
                <a-form-item label="绑定以下手机号码的用户不参加" name="excepet_users_frombindtel">
                    <associate-authorization v-model:value="formState.excepet_users_frombindtel" placeholder="请输入手机号码"
                        suffixTitle="回车或失去焦点后可以添加多个手机号码" inputType="text"></associate-authorization>
                </a-form-item>
                <a-form-item label="活动介绍" name="intro" :labelCol="{ span: 7 }" :wrapperCol="{ span: 15 }">
                    <Ueditor v-model:value="formState.intro" uid="u2"></Ueditor>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import Ueditor from '@/components/Ueditor/index.vue'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
import { AssociateAuthorization } from '@/components'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    modalTitle: string
    loading: boolean
    platformList: any[]
    isEdit: boolean
    roleOptions: any[]
}
const state = reactive<state>({
    modalTitle: '新增排队免单活动',
    loading: false,
    platformList: [],
    isEdit: false,
    roleOptions: []
})
const startTime = dayjs().format(format)
const endTime = dayjs().add(1, 'years').format(format)
interface formState {
    name: string
    platform_id: number | null
    business_types: any[]
    main_types: any[]
    registration_types: any[]
    queue_price: number | null
    max_out_num: number
    out_money: number
    out_type: number
    end_after_action: number
    take_money: number
    free_user_num: number
    free_rate: number[]
    status: number
    intro: string
    end_time: string | null
    start_time: string | null
    end_after_base_coupon: string | null
    per_user_jointimes: number
    restricted_roles: any[]
    excepet_users_frombindtel: string | undefined
}
let formState = reactive<formState>({
    name: '',
    platform_id: null,
    business_types: [1],
    main_types: [1, 2],
    registration_types: [1],
    queue_price: null,
    max_out_num: 0,
    out_money: 0,
    out_type: 1,
    end_after_action: 1,
    take_money: 0,
    free_user_num: 1,
    free_rate: [0],
    status: 1,
    intro: '',
    end_time: endTime,
    start_time: startTime,
    end_after_base_coupon: null,
    per_user_jointimes: 0,
    restricted_roles: [],
    excepet_users_frombindtel: undefined
})
let classList = ref()
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑【' + props.detailData.name + '】活动'
        state.isEdit = true
        queryDetail(props.detailData?.id)
    } else if (props.detailData?.name) {
        state.modalTitle = '复制【' + props.detailData.name + '】活动'
        Object.assign(formState, props.detailData)
    }
    platformList()
    queryRoleOptions()
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/freeactivity/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formState, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data.list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
//计算属性
const free_rateTotal = computed(() => {
    let total = 0
    formState.free_rate.forEach((item, index) => {
        if (index < formState.free_user_num) {
            total += Number(item)
        }
    })
    return total
})
const rangTime = computed(() => {
    let array: any = []
    if (formState.start_time && formState.end_time) {
        const startAndEnd_time: string[] = []
        startAndEnd_time[0] = formState.start_time
        startAndEnd_time[1] = formState.end_time
        array = startAndEnd_time.map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
const rangTimeChange = (val, str) => {
    if (val) {
        formState.start_time = str[0]
        formState.end_time = str[1]
    } else {
        formState.start_time = null
        formState.end_time = null
    }
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/freeactivity/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/freeactivity',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
const queryRoleOptions = () => {
    let requeryParam = {
        url: '/admin/user/create?id=' + props.detailData?.id,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.roleOptions = res.data.roles
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
</script>

<style lang="less" scoped></style>
